export default __webpack_public_path__ + "static/media/Pofchat Logo Biz.9497f891.png";